import lmsAPI from "./lmsAPI";

class PlanService {
  async show() {
    const res = await lmsAPI.get("/plan");
    return res.data;
  }

  async edit() {
    const res = await lmsAPI.get("/plan/edit");
    return res.data;
  }

  async update(planType) {
    const res = await lmsAPI.post(`/plan`, {
      plan_type: planType,
    });
    return res.data;
  }

  async confirm({ chargeId, type }) {
    const res = await lmsAPI.get(`/plan/confirmation`, {
      params: {
        charge_id: chargeId,
        type,
      },
    });
    return res.data;
  }
}

export default new PlanService();
